import { StripeExpressCheckoutElementOptions } from '@stripe/stripe-js'

import { PaymentMethodEnum, WalletPaymentMethod } from 'src/Constants/enums'

export const WALLET_BUTTON_BORDER_RADIUS = '40px'

const WALLET_BUTTON_HEIGHT = 48

const getButtonTheme = (
  resolvedTheme: 'light' | 'dark',
): StripeExpressCheckoutElementOptions['buttonTheme'] =>
  resolvedTheme === 'dark'
    ? { applePay: 'white-outline', googlePay: 'white' }
    : { applePay: 'black', googlePay: 'black' }

export const getWalletButtonOptions = (
  resolvedTheme: 'light' | 'dark',
  selectedWalletMethod?: WalletPaymentMethod,
): StripeExpressCheckoutElementOptions => ({
  buttonHeight: WALLET_BUTTON_HEIGHT,
  buttonTheme: getButtonTheme(resolvedTheme),
  buttonType: { applePay: 'buy', googlePay: 'pay' },
  paymentMethods: {
    link: 'never',
    paypal: 'never',
    klarna: 'never',
    amazonPay: 'never',
    applePay:
      selectedWalletMethod === PaymentMethodEnum.GOOGLE_PAY
        ? 'never'
        : 'always',
    googlePay:
      selectedWalletMethod === PaymentMethodEnum.APPLE_PAY ? 'never' : 'auto',
  },
})
